import { html } from '../core/html.js';
import { t } from '../core/i18n.js';
import { page, breadcrumbs } from '../components/chrome.js';
import { ctaSection } from '../components/ctaSection.js';
import { icon } from '../components/icon.js';

const measures = [
  {
    icon: 'play',
    titleKey: 'sustainability.measure1.title',
    textKey: 'sustainability.measure1.text',
  },
  {
    icon: 'code',
    titleKey: 'sustainability.measure2.title',
    textKey: 'sustainability.measure2.text',
  },
  {
    icon: 'scan',
    titleKey: 'sustainability.measure3.title',
    textKey: 'sustainability.measure3.text',
  },
  {
    icon: 'gamepad',
    titleKey: 'sustainability.measure4.title',
    textKey: 'sustainability.measure4.text',
  },
];

const pageHead = () => html`
  <section class="pagehead" aria-labelledby="sustainability-title">
    <div class="shell">
      ${breadcrumbs('nav.sustainability')}
      <div class="pagehead__grid">
        <div>
          <p class="kicker">${t('sustainability.label')}</p>
          <h1 class="pagehead__title" id="sustainability-title">${t('sustainability.title')}</h1>
          <p class="pagehead__lede">${t('sustainability.lede')}</p>
        </div>
        <aside class="pagehead__aside">
          <p class="kicker">${t('sustainability.aside.label')}</p>
          <p class="pagehead__note">${t('sustainability.aside.note')}</p>
          <p class="pagehead__meta">${t('sustainability.updated')}</p>
        </aside>
      </div>
    </div>
  </section>
`;

const intro = () => html`
  <section class="section" aria-labelledby="sustain-intro-title">
    <div class="shell">
      <div class="section-label">
        <span class="section-label__num">01</span>
        <span>${t('sustainability.intro.label')}</span>
      </div>
      <div class="sustain-intro__grid">
        <h2 class="sustain-intro__statement" id="sustain-intro-title">
          ${t('sustainability.intro.title')}
        </h2>
        <div class="sustain-intro__body">
          <p>${t('sustainability.intro.text1')}</p>
          <p>${t('sustainability.intro.text2')}</p>
        </div>
      </div>
    </div>
  </section>
`;

const measureList = () => html`
  <section class="section section--muted" aria-labelledby="measures-title">
    <div class="shell">
      <div class="section-label">
        <span class="section-label__num">02</span>
        <span>${t('sustainability.measures.label')}</span>
      </div>
      <div class="section-head">
        <h2 class="section-head__title" id="measures-title">${t('sustainability.measures.title')}</h2>
        <p class="section-head__lede">${t('sustainability.measures.lede')}</p>
      </div>

      <div class="measures">
        ${measures.map(
          (measure, index) => html`
            <article class="measure" data-reveal>
              <div class="measure__head">
                <span class="measure__num" aria-hidden="true">${String(index + 1).padStart(2, '0')}</span>
                <span class="measure__icon" aria-hidden="true">${icon(measure.icon, { size: 20 })}</span>
              </div>
              <h3 class="measure__title">${t(measure.titleKey)}</h3>
              <p class="measure__text">${t(measure.textKey)}</p>
            </article>
          `,
        )}
      </div>
    </div>
  </section>
`;

const limits = () => html`
  <section class="section" aria-labelledby="limits-title">
    <div class="shell">
      <div class="sustain-limits">
        <div>
          <p class="kicker">${t('sustainability.limits.label')}</p>
          <h2 class="sustain-limits__title" id="limits-title">${t('sustainability.limits.title')}</h2>
        </div>
        <div class="sustain-limits__body">
          <p>${t('sustainability.limits.text1')}</p>
          <p>${t('sustainability.limits.text2')}</p>
        </div>
      </div>
    </div>
  </section>
`;

export const SustainabilityPage = () => page(html`
  ${pageHead()}${intro()}${measureList()}${limits()}
  ${ctaSection({
    labelKey: 'sustainability.cta.label',
    titleKey: 'sustainability.cta.title',
    ledeKey: 'sustainability.cta.lede',
    buttonKey: 'sustainability.cta.button',
  })}
`);
